import { render, staticRenderFns } from "./productCenter.vue?vue&type=template&id=61d8bcae&scoped=true"
import script from "./productCenter.vue?vue&type=script&lang=js"
export * from "./productCenter.vue?vue&type=script&lang=js"
import style0 from "./productCenter.vue?vue&type=style&index=0&id=61d8bcae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d8bcae",
  null
  
)

export default component.exports